import { ScopeConfiguration } from './types';
import { ConfigurationRuleSetupType } from '@ydistri/api-sdk';

export function setConfigurationRuleSetupType(
  configuration: ScopeConfiguration,
  setupType: ConfigurationRuleSetupType,
  value: string,
): void {
  switch (setupType) {
    case ConfigurationRuleSetupType.IsEnabled:
    case ConfigurationRuleSetupType.UseAsSource:
    case ConfigurationRuleSetupType.UseAsTarget:
      configuration[setupType] = value === '1';
      return;
    case ConfigurationRuleSetupType.MaxNumberOfSourceStores:
    case ConfigurationRuleSetupType.MaxNumberOfTargetStores:
    case ConfigurationRuleSetupType.MaxNumberOfSourcePickingPositions:
    case ConfigurationRuleSetupType.MinimumRouteValue:
      configuration[setupType] = Number(value);
      return;
  }
}

export function configurationValueToString(
  setupType: ConfigurationRuleSetupType,
  value: number | boolean | null,
): string | null {
  if (value === null) return null;
  switch (setupType) {
    case ConfigurationRuleSetupType.IsEnabled:
    case ConfigurationRuleSetupType.UseAsSource:
    case ConfigurationRuleSetupType.UseAsTarget:
      return value ? '1' : '0';
    case ConfigurationRuleSetupType.MaxNumberOfSourceStores:
    case ConfigurationRuleSetupType.MaxNumberOfTargetStores:
    case ConfigurationRuleSetupType.MaxNumberOfSourcePickingPositions:
    case ConfigurationRuleSetupType.MinimumRouteValue:
      return value ? value.toString() : '0';
  }
}
